import React, { useEffect, useState } from 'react'
import { useLanguage } from '../context/languageContext';
import httpClient from '../shared/axios';
import { NavLink } from 'react-router-dom';
import iconPhone from '../images/icons/phone.svg'
import icongmail from '../images/icons/email.svg'

export default function Professors() {
    const { language } = useLanguage();
    const [data, setData] = useState([])
    useEffect(() => {
        const getActivities = async () => {
            const { data } = await httpClient.get(`/professors/?lang=${language === 'oz' ? 'uz-cyrl' : language}`)
            setData(data)
        }
        getActivities()

    }, [language])
    return (
        <div className='Professors'>
            <div className='container py-5'>
                <div className="row">
                    {data && data.map((item) => (
                        <NavLink to={`/professors/${item.id}`} key={item.id} className="col-lg-12 mb-3">
                            <div className="row">
                                <div className="col-3">
                                    {!!item.image ? <img className='person-img' src={item.image} alt={item.title} /> : null}
                                </div>
                                <div className="col-9">
                                    <h3 className='my-2'>{item?.first_name} {item?.last_name} {item?.last_name}</h3>
                                    <h4 className='mb-2'>{item?.position}</h4>
                                    <p className='mb-2'>{item?.specialty}</p>
                                    <a href={`tel:${item?.phone}`} className='mb-2'><img className='icon' src={iconPhone} alt="iconPhone" /> {item?.phone}</a> <br />
                                    <a href={`mailto:${item?.email}`} className='mb-2'><img className='icon' src={icongmail} alt="email" /> {item?.email}</a>
                                    {item?.orcid ? <p className='mb-2'><b>ORCID:</b> {item?.orcid}</p> : ''}
                                </div>
                            </div>

                            
                        </NavLink>
                    ))}
                </div>
            </div>
        </div>
    )
}
